// extracted by mini-css-extract-plugin
module.exports = {"root":"SubHeader_root__1fzz4","container":"SubHeader_container__Tbe_F"};